/**
 * Thrown when the environment has no write permissions on a project table at all.
 *
 * Its own module, not `projectSetupWrites`, because an error class should not drag the Apollo client
 * into everything that catches it: `projectSetupWrites` imports `ApolloClient`, which builds a
 * `graphql-ws` client at module load, which throws under Node with no WebSocket implementation. Any
 * unit test of a caller then fails at import rather than on its own terms.
 */
export class ProjectWriteUnavailableError extends Error {
  constructor(cause?: unknown) {
    super("Hasura write permissions for these tables are not deployed in this environment yet.", { cause });
    this.name = "ProjectWriteUnavailableError";
  }
}

/**
 * The base project was written but the setup rows the backend cannot compose it without —
 * project_location and project_calculation — were not (RTLCA-5595). Unlike the other post-create
 * writes, this is not a "finish in settings" failure: the settings page cannot even open such a
 * project, so the create flow surfaces it as a retryable error rather than a toast. The message is
 * user-facing — the start dialog shows it verbatim.
 */
export class ProjectSetupIncompleteError extends Error {
  constructor(cause?: unknown) {
    super("The project was created, but its setup could not be saved. Press Create project to retry.", { cause });
    this.name = "ProjectSetupIncompleteError";
  }
}

export default ProjectWriteUnavailableError;
